// assets
import { IconUsers } from '@tabler/icons';
import { createChildMenuItem, createChildGroupMenuItem, createMenuItem } from 'utils/menu';

// ==============================|| STUDENT ACCOUNTING MENU ITEMS ||============================== //

// Submenu items for student accounting
const studentAccountingItems = [
  createMenuItem('student-accounting-newmonth', 'student.accounting.newmonth.read', 'Murid Bulan Ini', '/student-accounting/newmonth', IconUsers, false),
  createMenuItem('student-accounting-active', 'student.accounting.active.read', 'Murid Aktif', '/student-accounting/active', IconUsers, false),
  createMenuItem('student-accounting-pending', 'student.accounting.pending.read', 'Murid Pending', '/student-accounting/pending', IconUsers, false)
];

const children = [
  {
    id: 'student-accounting',
    perm: 'student.accounting.read', // Permission untuk collapse parent
    title: 'Data Murid (Accounting)',
    type: 'collapse',
    icon: IconUsers,
    children: createChildMenuItem(studentAccountingItems)
  }
];

const studentaccounting = {
  id: 'student-accounting-group',
  title: '',
  type: 'group',
  children: createChildGroupMenuItem(children)
};

export default studentaccounting;

